<template>
  <b-modal
    :model-value="active"
    has-modal-card
    trap-focus
    :can-cancel="['escape', 'x', 'outside']"
    @update:model-value="$emit('update:active', $event)"
  >
    <div class="modal-card" style="width: 720px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button
          type="button"
          class="delete"
          :aria-label="$t('general.close')"
          @click="$emit('update:active', false)"
        />
      </header>
      <section class="modal-card-body">
        <Chapter7ZielCard
          v-if="ziel"
          v-model:ziel="ziel"
          :index="index"
          :partner-intern-extern="partnerInternExtern"
        />
      </section>
      <footer class="modal-card-foot">
        <b-button type="is-link" @click="$emit('update:active', false)">
          {{ $t('general.save') }}
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import { BButton, BModal } from 'buefy'
import Chapter7ZielCard from '@/components/Chapter7ZielCard.vue'
import type { DatenUebertragungsZiel } from '@/types/studyTypes'

const ziel = defineModel<DatenUebertragungsZiel | undefined>('ziel')

defineProps<{
  active: boolean
  index: number
  partnerInternExtern: 'intern' | 'extern'
  title: string
}>()

defineEmits<{ 'update:active': [value: boolean] }>()
</script>

<style scoped>
.modal-card-head {
  padding: 0.75rem 1.5rem;
}

.modal-card-title {
  font-size: 1.25rem;
}
</style>
